import { motion } from "framer-motion";
import "./Contact.css";

export default function Contact() {
  const whatsappNumber = "61435245552"; // Replace with your WhatsApp number (no + or spaces)
  const phoneNumber = "+61 435 245 552"; // Replace with your real phone number

  return (
    <section className="contact-page">
      <div className="contact-overlay">
        <motion.div
          className="contact-content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Contact Us</h1>
          <p>
            Have a question or want to join our training sessions? Reach out — we’ll get back to you as soon as possible!
          </p>

          <div className="contact-buttons">
            {/* WhatsApp Button */}
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              Message on WhatsApp
            </a>

            {/* Call Button */}
            <a href={`tel:${phoneNumber}`} className="call-btn">
              Give Us a Call
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
